import { render, staticRenderFns } from "./LabelListProduct.vue?vue&type=template&id=11d2da6d"
import script from "./LabelListProduct.vue?vue&type=script&lang=js"
export * from "./LabelListProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports